import React, { useState } from "react";
import toast from "react-hot-toast";
import { approveRequests } from "../../services/organisation";

const DeclineOrgModal = ({ isOpen, onClose, requests }) => {
  const [reason, setReason] = useState("");

  if (!isOpen) return null;

  const handleDecline = async () => {
    if (!reason.trim()) {
      toast.error("Please provide a decline reason"); // Or use toast
      return;
    }
    try {
      const res = await approveRequests({
        id: requests.Id,
        status: "declined",
        declineReason: reason,
      });
      toast.error(res.message);
      onClose();
    } catch (error) {
      if (error.response) {
        toast.error(error?.response?.data?.message);
      }
    }
    setReason(""); // Reset textarea
  };

  const handleCancel = () => {
    setReason("");
    onClose();
  };

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-black bg-opacity-40 z-40"
        onClick={handleCancel}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div
          className="bg-white rounded-lg w-[400px] max-w-full p-6 relative"
          onClick={(e) => e.stopPropagation()} // Prevent backdrop click closing when clicking modal
        >
          <h2 className="text-lg font-semibold mb-4">Decline Request</h2>

          {/* Textarea */}
          <div className="mb-4">
            <label
              htmlFor="declineReason"
              className="block text-sm font-medium mb-1"
            >
              Decline Reason
            </label>
            <textarea
              id="declineReason"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              rows={4}
              className="w-full border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-text-orange resize-none"
              placeholder="Enter reason for declining..."
            />
          </div>

          {/* Buttons */}
          <div className="flex justify-end gap-3">
            <button
              onClick={handleCancel}
              className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
            >
              Cancel
            </button>
            <button
              onClick={handleDecline}
              className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
            >
              Decline
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeclineOrgModal;
